import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ForgotPasswordResponse {
  accepted: boolean;
}

export interface ResetPasswordResponse {
  passwordReset: boolean;
  failureCode?: string;
}

@Injectable({ providedIn: 'root' })
export class PasswordRecoveryService {
  constructor(private readonly http: HttpClient) {}

  requestReset(email: string): Observable<ForgotPasswordResponse> {
    return this.http.post<ForgotPasswordResponse>(
      `${environment.apiBaseUrl}/api/auth/forgot-password`,
      { email }
    );
  }

  resetPassword(
    token: string,
    newPassword: string
  ): Observable<ResetPasswordResponse> {
    return this.http.post<ResetPasswordResponse>(
      `${environment.apiBaseUrl}/api/auth/reset-password`,
      { token, newPassword }
    );
  }
}